<template>
  <div class="service-item-component">
    <div class="service-item-wrapper">
      <div class="service-item align-center">
        <div class="service-item-label">{{ service.name }}</div>

        <div class="service-item-price">{{ service.price_with_currency }}</div>

        <div class="service-item-suffix">{{ service.suffix }}</div>

        <div class="button-wrapper">
          <button v-if="isDomain" class="big-purple-button" @click="openDomainModal()">Buy {{ service.name }}</button>
        </div>
      </div>
    </div>

    <ServiceDomainModal
        v-if="isDomain"
        :show="showDomainModal"
        :route-check="routeCheckDomain"
        :route-payment-pay-pal="routePaymentPayPal"
        :route-payment-world-pay="routePaymentWorldPay"
        :service="service"
        :illustrator="illustrator"
        @close="closeDomainModal()"
    />
  </div>
</template>

<script>
import ServiceDomainModal from './ServiceDomainModal';

export default {
  props: {
    service: {
      type: Object
    },

    illustrator: {
      type: Object
    },

    routeCheckDomain: {
      type: String
    },

    routePaymentPayPal: {
      type: String
    },

    routePaymentWorldPay: {
      type: String
    },
  },

  data() {
    return {
      isDomain: this.service.slug === 'domain_name',

      showDomainModal: false
    };
  },

  components: {
    ServiceDomainModal
  },

  methods: {
    openDomainModal() {
      this.showDomainModal = true;
    },

    closeDomainModal() {
      this.showDomainModal = false;
    },
  }
};
</script>

<style scoped>
  .service-item-component {
    display: inline;
  }
</style>
